import {ChangeDetectionStrategy, Component, input} from '@angular/core'
import {ListModule} from '../../../craft/list/list.module'
import {AccordionModule} from '../../../craft/accordion/accordion.module'
import {CarouselAccordionComponent} from '../../../craft/carousel-accordion-section/carousel-accordion.component'
import {BehaviorSubject} from 'rxjs'
import {PresentationSection} from '../../../core/content/types/presentation-section.types'
import {RichTextModule} from '../rich-text/rich-text.module'
import {ButtonModule} from '../../../craft/button/button.module'
import {YoutubeVideoModule} from '../../../craft/youtube-video/youtube-video.module'
import {NgOptimizedImage} from '@angular/common'
import {DatoCmsGifPipe} from '../../pipes/datocms.pipe'

@Component({
  selector: 'bgo-presentation-section',
  templateUrl: './presentation-section.component.html',
  styles: `
    :host {
      display: block;
    }
  `,
  imports: [
    ListModule,
    AccordionModule,
    CarouselAccordionComponent,
    YoutubeVideoModule,
    RichTextModule,
    ButtonModule,
    NgOptimizedImage,
    DatoCmsGifPipe,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PresentationSectionComponent {
  section = input.required<PresentationSection>()
  layout = input<'h-layout' | 'h-content-layout'>('h-content-layout')

  protected readonly index$ = new BehaviorSubject(0)

  changeIndex(index: number) {
    this.index$.next(index)
  }

  getLetter(index: number): string {
    return `${index + 1}`
  }
}
